/**
* Created by kongwm.kong on 2017/7/24.
*/
<template>
    <div class="net-detail-wrap form-page-wrap">
        <div class="bread-wrap">
            <div class="layout_n">
                <router-link to="/net">净值管理</router-link> > <span> {{netType==1 ? '已加入净值' : netType==2 ? '待加入净值': '新增净值'}}</span>
            </div>
        </div>
        <div class="layout_n margin">
            <div class="message_content">
                <div class="process_wrap">
                    <div class="liner">
                        <div :class="{ 'line':true, 'line2': netType==2, 'line3': netType==3}"></div>
                    </div>
                    <!--步骤开始-->
                    <div class="step_wrap clearfix" >
                        <div :class="{ 'step': true, 'now': netType==1 , 'prev': netType > 1}">
                            <div class="step_line">
                                <div :class="{'first': netType==2||netType==3 , 'line': true}"></div>
                                <div class="radius_wrap">
                                    <div class="radius">1</div>
                                </div>
                            </div>
                            <div class="text">编辑净值信息</div>
                        </div>
                        <div :class="{ 'step': true, 'now': netType==2 , 'prev': netType > 2}">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">2</div>
                                </div>
                            </div>
                            <div class="text">信息审核中</div>
                        </div>
                        <div :class="{ 'step': true, 'now': netType==3 }">
                            <div class="step_line">
                                <div class="line"></div>
                                <div class="radius_wrap">
                                    <div class="radius">3</div>
                                </div>
                            </div>
                            <div class="text">信息发布</div>
                        </div>
                    </div>
                </div>
                <div class="item-wrap">
                    <form @submit.prevent="goSubmit">
                        <!--基本信息-->
                        <div class="item">
                            <div class="title"><div class="sub-title">基本信息</div></div>
                            <div class="baseinfo-wrap">
                                <!--一系列表单-->
                                <ul class="clearfix">
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">基金简称</label>
                                            <div class="select-ul-wrap">
                                                <vue-select  :name="'productName'" :readonly="netType==2" @closed="getProductNameFlag" :idSelectName="'fundDcId'" :id="dataNet.productCode"  @selected="getProductName" v-model="dataNet.productName" :selectKey="'prdShortName'" :selectList="productNameList"></vue-select>
                                            </div>
                                        </div>
                                        <div class="err">
                                            <!--<span v-show="errors.has('prdShortName')">{{errors.first('prdShortName')}}</span>-->
                                            <span v-show="!netMsg.productNameFlag">请选择基金简称</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label">基金ID</label>
                                            <input type="text" v-model="dataNet.productCode" readonly name="productCode" >
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">净值日期</label>
                                            <!-- <input type="text" name="pubDate" placeholder="填写基金名称,不超过20字"> -->
                                            <div class="date-wrap" v-if="netType!=2">
                                                <date-picker class="date-time date-time-wrap" placeholder="填写净值日期"  language="zh" @closed="getFlag" :format="'yyyy-MM-dd'" name="pubDate" v-model="dataNet.pubDate1"  :input-class="'input'"></date-picker>
                                            </div>
                                                <input  v-else type="text" v-model="netMsg.pubDate2" :readonly="netType==2"  name="pubDate" placeholder="">
                                        </div>
                                        <div class="err">
                                            <span v-show="netMsg.pubDateFlag">请选择净值日期</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class=" label required">单位净值</label>
                                            <input type="text" v-model="dataNet.unitNet"  :readonly="netType==2" name="unitNet" v-validate="'required|netValid'"  placeholder="填写单位净值">
                                        </div>
                                        <div class="err">
                                            <span v-show="errors.has('unitNet')">{{errors.first('unitNet')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class="label required">累计净值</label>
                                            <input type="text" :readonly="netType==2" name="accountNet" v-model="dataNet.accNet"  v-validate="'required|netValid'"  placeholder="填写累计净值">
                                        </div>
                                        <div class="err">
                                             <span v-show="errors.has('accountNet')">{{errors.first('accountNet')}}</span>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="input_wrap">
                                            <label class="label required">复权累计净值</label>
                                            <input type="text" v-model="dataNet.adjustedNet" :readonly="netType==2" name="facNet" v-validate="'required|netValid'" placeholder="填写复权累计净值">
                                        </div>
                                        <div class="err">
                                           <span v-show="errors.has('facNet')">{{errors.first('facNet')}}</span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                            <!--提交按钮-->
                            <div class="btn-commit-wrap" v-show="netType!=2">
                                <button class="btn-bg-def commit btn" type="submit">提交</button>
                                <button class="btn-def save  btn" @click="goToSave">保存暂不提交</button>
                            </div>
                            <p class="ps-hot">温馨提示：审核期间不可编辑基金信息</p>
                        </div>
                    </form>
                </div>
                <div class="item-wrap">
                    <div class="item">
                        <div class="title"><div class="sub-title">导入净值（Excel批量导入）</div></div>
                        <div class="btn-net-wrap">
                            <div class="btn-bg-def comeExcel btn">
                                <up-load :labelText="'导入净值'"  :successMessage="'净值导入成功'"  :isExcel="true" :postURL="postURL"></up-load>
                            </div>
                            <a class="btn-bg-def download  btn" target="_blank"  href="https://jfz-stock.oss-cn-hangzhou.aliyuncs.com/common/prod/%E5%87%80%E5%80%BC%E6%A8%A1%E6%9D%BF.xls">下载模板</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <submit-ok :isSave="isSave" @closeModal="golist"></submit-ok>
    </div>
</template>
<script>
//    import datePicker from 'vuejs-datepicker';
    import datePicker from '../../components/middleware/Datepicker';
    import upLoad from '../../components/common/upload';
    import tool from '../../assets/js/common/tool'
    import submitOk from '../../components/modal/submitOk';
    import vueSelect from '../../components/form/select.vue'
    export default {
        props: {
            dataItem: {

          }
        },
        data (){
            return {
                isSave: false,
                postURL:'/networth/batchImport',
                netType: 1,
                suggestionAttribute: 'prdShortName',
                productNameList:[],
                dataNet: {
                    productName: null,
                    productCode: null,
                    unitNet: null,
                    pubDate1: null,
                    accNet: null,
                    adjustedNet: null,
                    fundDcId: null
                },
                pubDate1: '',
                netMsg:{
                    pubDateFlag : false,
                    pubDate2: '',
                    prdName: '',
                    productNameFlag: true
                },
                msg: {
                    pubDate2: ''
                }
            }
        },
        components:{
            datePicker,
            upLoad,
            submitOk,
            vueSelect
        },
        mounted(){
            this.geDetail();
        },

        watch: {
            '$route'(){
                this.geDetail();
            }
        },
        created(){
            this.$store.commit('getLoginInfo');
            this.getProductNameList();
        },
        methods:{
            geDetail(){
                this.netId = this.$route.params.id;
                this.netType1 = this.$route.params.type;
                let data = this.$route.query.data;
                if(this.netType1 == 1){
                    this.netType = 3
                }
                if(typeof data ==='string'){
                    this.dataNet = JSON.parse(data);
                    this.initData();
                    this.dataNet.accNet = tool.toFixed1(this.dataNet.accNet, 4);
                    this.dataNet.adjustedNet = tool.toFixed1(this.dataNet.adjustedNet, 4);
                    this.dataNet.unitNet = tool.toFixed1(this.dataNet.unitNet, 4);
                    if(this.dataNet.auditStatus != null &&typeof  this.dataNet.auditStatus != 'undefined' ){
                        if(this.netType1 == 2 && this.dataNet.auditStatus == 0){
                            this.netType = 2
                        }
                    }
                }
            },
            initData(){
                this.netMsg.pubDate2 = tool.transformTime(this.dataNet.pubDate, 'yyyy-mm-dd');
                this.dataNet.pubDate1 = tool.numToDate(this.dataNet.pubDate) ;//this.dataNet.pubDate ?  new Date(this.dataNet.pubDate) : '';
            },
            getFlag(){
                if(this.dataNet.pubDate1){
                    this.netMsg.pubDateFlag = false;
                }else {
                    this.netMsg.pubDateFlag = true;
                }
            },
            getProductNameFlag(){
//                console.log(this.dataNet.productName);
                if(this.dataNet.productName =='' ||this.dataNet.productName==null){
                    this.netMsg.productNameFlag = false;
                } else if(this.dataNet.productCode == null || this.dataNet.productCode ==''){
                    this.netMsg.productNameFlag = false;
                } else {
                    this.netMsg.productNameFlag = true;
                }
            },
            /*选择基金简称*/
            getProductName(obj){
                this.dataNet.productName = obj.prdShortName;
                this.dataNet.productCode = obj.fundDcId;
                this.netMsg.productNameFlag = true;
            },
            /*搜索*/
            getProductNameList(){
                this.$http.request({
                    url: `/product/list/sample`
                }, res =>{
                    if(res.data.code === 200){
                        this.productNameList = res.data.data;
                    } else {
                        this.productNameList = [];
                    }
                }, err => {
                    this.productNameList = [];
                });
            },
            /*提交前数据处理*/
            beforeData(){
                if(this.netType == 3){ //已加入
                    this.$delete(this.dataNet, 'id');
                }
                this.dataNet.pubDate = tool.dateToNum(this.dataNet.pubDate1);
            },
            showModal(){
                this.$modal.show('submitOk');
//                this.$router.push('/net');
            },
            golist(){
                this.$router.push({path: '/net', query:{item: 2}});
            },
            goSubmit(){
                this.getFlag();
                this.getProductNameFlag();
                this.$validator.validateAll().then(result=>{
                    if(result && !this.netMsg.pubDateFlag && this.netMsg.productNameFlag){
                        this.beforeData();
                        this.$http.request({
                            url: `/networth/saveOrUpdateThenAudit`,
                            method: 'post',
                            data: this.dataNet
                        }, response =>{
                            if(response.data.code == 200){
                                this.isSave = false;
                                this.showModal();
                            }
                        }, err => {
                        });

                    }
                })
            },
            goToSave(e){
                e.preventDefault();
                this.beforeData();
                this.$http.request({
                    url: `/networth/saveOrUpdate`,
                    method: 'post',
                    data: this.dataNet
                }, response =>{
                    if(response.data.code == 200){
                        this.isSave = true;
                        this.showModal();
                    }
                }, err => {
                });
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    @import "../../assets/css/common/form";
    .message_content{
        @include bgff;
        padding: 1px 40px 55px;
        .btn-net-wrap{ // 导入净值按钮
            text-indent: 150px;
            .comeExcel, .download{
                display: inline-block;
                width:204px;
                height: 50px;
                background: $btn_408;
                color: #fff;
                vertical-align: middle;
                text-indent: 0;
                line-height: 50px;
                text-align: center;
            }
            .comeExcel{
                overflow: hidden;
                position: relative;
            }
            .download{
                margin-left: 30px;
                font-size: 18px;
                font-weight: bold;
            }

        }
    }
</style>
<style lang="scss" type="text/scss">
    .date-time-wrap{
        /*height: 36px;*/
        /*width: 100%;*/
        /*!*border: 1px solid #bfbfbf;*!*/
        /*border-radius: 4px;*/
        /*input{*/
            /*padding: 5px 0;*/
            /*padding-left: 10px;*/
        /*}*/
        ::placeholder{
            font-size: 14px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/netMana/detail.vue